import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import configData from "config.json";
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { SolicitudVacacionesRechazoDTO } from "../../DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes";
import { alertService } from "../../Varios/alert_service";
import { EmpleadoHorario, InformacionGeneralSolicitudes, SolicitudPost } from "./TypesCambioHorarioPRN";

export async function ObtenerInformacionGeneralSolCambioHorario(handleError: (info?: any) => void) {
    const url = configData.SERVER_URL + "SolicitudCambioHorarioPRN/InformacionGeneral";
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionSolicitud: InformacionGeneralSolicitudes = {
        feriados: [],
        historialSolicitudes: [],
        tieneAcuerdoMediosElectronicos: true,
        empHorario: [],
        horaFinAlmuerzo: "",
        horaInicioAlmuerzo: "",
        tiempoAlmuerzo: "",
        solicitudesIngresadas: []

    }

    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionSolicitud }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionSolicitud = respuesta.data;

        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionSolicitud,
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionSolicitud,
                errorMessage: error.response.data ?? ""
            }
            handleError(infoResponse.errorMessage);
        }
        else {
            handleError();
        }
    }

    return infoResponse;

}

export async function SolicitarFormulario(solicitud: SolicitudPost, acuerdoMediosElectronicos: boolean) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }

    var URL_DOCUMENTO = "SolicitudCambioHorarioPRN/SolicitarCambioHorario/VistaPreviaFormulario";


    
    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} `
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )

        const blob_resource = await respuesta.data;
        const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
        else if (axios.isAxiosError(error) && !error.response) {
            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
        }
    }
    return respuestaResponse
}

export async function ConfirmarFormulario(solicitud: SolicitudPost, acuerdoMediosElectronicos: boolean) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }

    var URL_DOCUMENTO = "SolicitudCambioHorarioPRN/SolicitarCambioHorario/VistaPreviaFormulario";



    const url = `${configData.SERVER_URL}${URL_DOCUMENTO} `
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )

        const blob_resource = await respuesta.data;
        const url_documento = window.URL.createObjectURL(blob_resource);
        respuestaResponse = { status: respuesta.status, dataResponse: url_documento }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
        else if (axios.isAxiosError(error) && !error.response) {
            respuestaResponse = { status: -1, errorMessage: "No ha sido posible contactar con el servidor. Intente más tarde." }
        }
    }
    return respuestaResponse
}

export async function SolicitarCambioHorarioCreacion(solicitud: SolicitudPost) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const url = configData.SERVER_URL + "SolicitudCambioHorarioPRN/CrearSolicitudCambioHorario"

    
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithToken(infoUsuario.token),
            }
        )
        respuestaResponse = { status: respuesta.status, dataResponse: respuesta.data }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data }

        }
    }
    return respuestaResponse
}

export async function AnularSolicitudCambioHorario(idSolicitud: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    const URL = configData.SERVER_URL + `SolicitudCambioHorarioPRN/AnularSolicitudCambioHorario/${idSolicitud}`

    try {
        const respuesta = await axios.put(URL, {}, {
            headers: authHeaderWithToken(infoUsuario.token)
        })

        return 1
    } catch (error) {
        return -1

    }



}

